import {useTimedOut} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

// https://docs.rokt.com/developers/integration-guides/web/advanced/preparative-iframe
export const PreloadRoktProvider = () => {
  const isTimedOut = useTimedOut(7500);

  if (!isTimedOut) {
    return null;
  }

  return (
    <HiddenIfame
      aria-hidden="true"
      src="https://apps.rokt.com/wsdk/preload/index.html"
      sandbox="allow-scripts allow-same-origin"
    />
  );
};

const HiddenIfame = styled.iframe`
  border: 0px;
  width: 100%;
  display: none;
`;
